var PushNotification = require("./../v2/js/push-notification/PushNotification")
    .default;
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
var moment = require("moment");

var AJAX_PREFIX = "/api";

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const GENDER_TYPE = [
    {
        name: "Male",
        id: "male",
    },
    {
        name: "Female",
        id: "female",
    },
    {
        name: "Prefer not to disclose",
        id: "prefer not to disclose",
    },
];

const VACCINE_STATUS_LIST = [
    {
        id: "not_vaccinated",
        name: "Not Vaccinated",
    },
    {
        id: "partially_vaccinated",
        name: "Partially Vaccinated",
    },
    {
        id: "fully_vaccinated",
        name: "Fully Vaccinated",
    },
];

const VACCINE_STATUS_MAPPING = {
    not_vaccinated: "Not Vaccinated",
    partially_vaccinated: "Partially Vaccinated",
    fully_vaccinated: "Fully Vaccinated",
};

const VACCINE_STATUS_CLASS_MAPPING = {
    not_vaccinated: "expiredPackage",
    partially_vaccinated: "",
    fully_vaccinated: "",
};

export { GENDER_TYPE, VACCINE_STATUS_LIST, VACCINE_STATUS_MAPPING, VACCINE_STATUS_CLASS_MAPPING };

$(document).ready(function() {
    $("#logout-btn").click(function(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        window.localStorage.removeItem("@traqade-push-popup");
        window.location.href = "/staff/logout";
        return false;
    });
});

Vue.directive("selectTwo", {
    twoWay: true,
    bind: function(el) {
        var curEle = el;
        var vm = this;
        setTimeout(function() {
            $(el)
                .select2({
                    theme: "bootstrap",
                    minimumResultsForSearch: Infinity,
                    width: "100%",
                })
                .on("select2:select", function(e) {}.bind(this));
        }, 1);
    },
    update: function(el, ov) {},
});
/*commoly used functions start*/
Vue.mixin({
    filters: {
        ucWords: function(value) {
            if (!value) return "";
            value = value.toString();
            return (value + "").replace(/^([a-z])|\s+([a-z])/g, function($1) {
                return $1.toUpperCase();
            });
        },
        isEmptyObject: function(object) {
            return object == null || object === JSON.stringify({});
        },
        convertToDateFormat: function(dateStr) {
            return moment(dateStr).format("DD/MM/YYYY");
        },
        convertToDateTimeFormat: function(dateStr) {
            return moment(dateStr).format("DD/MM/YYYY HH:mm");
        },
        convertToTimeFormat: function(dateStr) {
            return moment(dateStr).format("HH:mm");
        },
        convertToJavaDateTimeFormat: function(dateStr) {
            return moment(dateStr).format("YYYY-MM-DD HH:mm:ss");
        },
        convertToTimeFormatWithPeriod: function(dateStr) {
            return moment(dateStr).format("hh:mm A");
        },
        formatDateAndTime: function(dateTime) {
            var dateFormat = "Do MMM YYYY, hh:mm A";
            return moment(String(dateTime)).format(dateFormat);
        },
        formatDate: function(dateTime) {
            var dateFormat = "Do MMM YYYY";
            return moment(String(dateTime)).format(dateFormat);
        },
        checkAndFormatDate: function(date) {
            var dateStr = new Date(date).toString();
            if (dateStr !== "Invalid Date") {
                return moment(String(date)).format("Do MMM YYYY, hh:mm A");
            }
            return "NA";
        },
        isEmail: function(value) {
            return (isEmail = /^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
                value
            ));
        },
        isMobile: function(value) {
            return (isMobile = /^$|^[6-9][0-9]{9}$/.test(value));
        },
        implode: function(value, key, separator) {
            separator = separator ? separator : ", ";
            if (key === undefined) {
                return value.join(separator);
            }
            var arrayKeyValue = [];
            value.forEach((val) => {
                arrayKeyValue.push(val[key]);
            });
            return arrayKeyValue.join(separator);
        },
        convertCurrency(number) {
            return new Intl.NumberFormat(
                `en-${window.userCurrency.countryIsoCode}`,
                {
                    style: "currency",
                    currency: window.userCurrency.currencyCode,
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                }
            ).format(number);
        },
    },
    updated: function() {
        $('[data-toggle="popover"]').popover();
        $('[data-toggle="tooltip"]').tooltip({
            trigger: "hover",
        });
        $(".packs").popover({
            html: true,
            trigger: "hover",
            content: function() {
                return $(this)
                    .next(".popover-content-packs")
                    .html();
            },
        });
        $(".tqScrollbar").mCustomScrollbar({
            theme: "minimal-dark",
            scrollInertia: "100",
        });
    },
    methods: {
        firstCloumnClass: function(ind) {
            var classList = [
                "br-primary",
                "br-info",
                "br-success",
                "br-warning",
                "br-danger",
            ];
            var length = classList.length;
            var rInd = ind;
            if (ind >= length) {
                rInd = ind - length;
            }
            return ["first-letter", classList[rInd]];
        },
        firstCloumnActiveClass: function(ind) {
            var classList = ["br-danger", "br-success", "br-warning"];
            var clas = classList[ind] ? classList[ind] : classList[2];
            return ["first-letter", clas];
        },
        firstCloumnSatusClass: function(status) {
            status = status.toLowerCase();
            var classList = {
                new: "br-success",
                open: "br-warning",
                closed: "br-danger",
                default: "br-info",
            };
            var clas = classList[status]
                ? classList[status]
                : classList["default"];
            return ["first-letter", clas];
        },
        leadTypeClass: function(type) {
            type = type.toLowerCase();
            var classList = {
                hot: "text-danger",
                warm: "text-primary",
                cold: "textBlue",
                default: "br-info",
            };
            var clas = classList[type] ? classList[type] : classList["default"];
            return [clas];
        },
        truncate: function(stringVal, value) {
            if (typeof stringVal != "undefined") {
                return stringVal.substring(0, value);
            }
            return "";
        },
        startLoading: function() {
            document.getElementById("pageLoader").style.display = "block";
            document.getElementById("body-wrapper").style.display = "none";
        },
        stopLoading: function() {
            document.getElementById("pageLoader").style.display = "none";
            document.getElementById("body-wrapper").style.display = "block";
        },
        joinCenter: function(userCode, centerCode) {
            joinCenterBtnLoader = Ladda.create(
                document.querySelector(".joinCenterBtn")
            );
            joinCenterBtnLoader.start();
            var linkData = {
                userCode: userCode,
                centerCode: centerCode,
            };
            this.$http.post("/user/center/authorize", linkData).then(
                (response) => {
                    joinCenterBtnLoader.stop();
                    joinCenterBtnLoader.remove();
                    if (response.body.hasError) {
                        toastr["error"](response.body.message);
                    } else {
                        toastr["success"](response.body.message);
                        $("#joinCenterBtn" + centerCode).hide();
                    }
                },
                (response) => {
                    joinCenterBtnLoader.stop();
                    joinCenterBtnLoader.remove();
                }
            );
        },
    },
});

Vue.http.interceptors.push((request, next) => {
    request.url = AJAX_PREFIX + request.url;
    console.log(request);
    next((response) => {
        if (response.status == 401) {
            $("#modal-popup").modal("show");
        }
    });
});

window.FAQquestion = new Vue({
    el: "#faqQuestion",
    methods: {
        openAskQuestionForm: function() {
            askAQuestion.getUserDetails();
            $("#askQuestion").modal("show");
        },
    },
});

var askAQuestion = new Vue({
    el: "#askQuestion",
    data: {
        errorMessage: "",
        queryData: {
            name: "",
            email: "",
            mobile: null,
        },
    },
    methods: {
        getUserDetails: function() {
            this.$http.get("/staff/details/get").then((response) => {
                if (response.data.hasError) {
                    return false;
                }
                this.userDetails = response.data.result;
                this.queryData.name = this.userDetails.firstName;
                this.queryData.email = this.userDetails.email;
                this.queryData.mobile = this.userDetails.mobile;
            });
        },
        traqadeAskQuestion: function(e) {
            var askLoader = Ladda.create(
                document.querySelector(".askBtnLoader")
            );
            this.errorMessage = "";
            var isValid = validate.formIsValid("traqadeQuery", true);
            if (!isValid) {
                return false;
            }
            var formData = this.queryData;
            askLoader.start();
            this.$http.post("/push/lead/query", formData).then(
                (response) => {
                    if (response.body.hasError) {
                        askLoader.stop();
                        askLoader.remove();
                        this.errorMessage = "Something went wrong";
                        toastr["error"]("Something went wrong!", "FAILED!");
                        return false;
                    }
                    this.queryData.op_message = "";
                    this.errorMessage = "";
                    askLoader.stop();
                    askLoader.remove();
                    $("#askQuestion").modal("hide");
                    toastr["success"](response.body.message);
                },
                (response) => {
                    askLoader.stop();
                    askLoader.remove();
                    this.errorMessage = "Something went wrong!";
                    toastr["error"]("Something went wrong!", "Failed");
                }
            );
        },
    },
});

var search = new Vue({
    el: "#topFilterForm",
    data: {
        searchTerm: "",
        searchPage: "lead",
        searchData: {
            name: {
                name: "Name",
                partial: false,
                textValue: "",
                value: "",
            },
        },
    },
    mounted: function() {
        $("#searchSelect ul li a").click(function() {
            search.searchPage = $(this).data("page");
        });
        $("#searchSelectSub li a").click(function() {
            search.searchPage = $(this).data("page");
        });
    },
    methods: {
        searchPages: function() {
            this.searchData["name"].textValue = this.searchData[
                "name"
            ].value = this.searchTerm.trim();
            if (this.searchPage == "lead") {
                localStorage.setItem(
                    "lsFiltersData",
                    JSON.stringify(this.searchData)
                );
                window.location.href = "/leads";
            } else if (this.searchPage == "member") {
                localStorage.setItem(
                    "memFiltersData",
                    JSON.stringify(this.searchData)
                );
                window.location.href = "/members";
            } else if (this.searchPage == "staff") {
                localStorage.setItem(
                    "stfFiltersData",
                    JSON.stringify(this.searchData)
                );
                window.location.href = "/staff";
            }
        },
    },
});

var selectUser = new Vue({
    el: "#userSelect",
    data: {
        userList: {},
    },
    methods: {
        setCenterFromHead: function(centerCode) {
            var linkData = {
                centerCode: centerCode,
            };
            this.$http.post("/staff/center/set", linkData).then(
                (response) => {
                    if (response.body.hasError) {
                        toastr["error"](response.body.message);
                    } else {
                        window.location.href = "/";
                    }
                },
                (response) => {}
            );
        },
        joinCenter: function(userCode, centerCode) {
            joinCenterBtnLoader = Ladda.create(
                document.querySelector(".joinCenterBtn")
            );
            joinCenterBtnLoader.start();
            var linkData = {
                userCode: userCode,
                centerCode: centerCode,
            };
            this.$http.post("/user/center/authorize", linkData).then(
                (response) => {
                    joinCenterBtnLoader.stop();
                    joinCenterBtnLoader.remove();
                    if (response.body.hasError) {
                        toastr["error"](response.body.message);
                    } else {
                        toastr["success"](response.body.message);
                        this.getUserMappedCenters();
                        $("#joinCenterBtn" + centerCode).hide();
                    }
                },
                (response) => {
                    joinCenterBtnLoader.stop();
                    joinCenterBtnLoader.remove();
                }
            );
        },
    },
});

new Vue({
    el: "#notification-wrapper",
    components: {
        "push-notification": PushNotification,
    },
});

import ExpiryNotification from "./../v2/js/expiry-notification/ExpiryNotification";
new Vue({
    el: "#expiry-notification-wrapper",
    components: {
        "expiry-notification": ExpiryNotification,
    },
});

/*commoly used functions end*/
require("./lead/leadAddUpdate");
require("./member/memberAddUpdate");
require("./staffAddUpdate");
require("./mailCompose/wysiwyg");
require("./mailCompose/inbox");
